// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1qWRi","prevNextPageBtn":"styles_prevNextPageBtn__vlTjF","text":"styles_text__2vqxO","input":"styles_input__2PRG2","select":"styles_select__15YNI"};